import { render, staticRenderFns } from "./startForceBpmByKey.vue?vue&type=template&id=6b466b3b"
import script from "./startForceBpmByKey.vue?vue&type=script&lang=js"
export * from "./startForceBpmByKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports